import { useTranslation } from 'react-i18next';
import { Container } from '../theme/primitives';


function Login() {
  const { t } = useTranslation();

  return (
    <Container>
      {t('login.placeholder')}
    </Container>
  );
}

export default Login;
